import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { EaseBuzzAPIService } from "../../services/easbuzz-api-service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";
import { flatMap } from "rxjs/operators";
import { Location } from "@angular/common";

@Component({
  selector: "app-redeem-loyalty",
  templateUrl: "./redeem-loyalty.component.html",
  styleUrls: ["./redeem-loyalty.component.css"],
})
export class RedeemLoyaltyComponent implements OnInit {
  vObj;
  tranComplete = false;
  option = "1";
  isUPI: boolean = true;
  isBank: boolean = true;
  isPaytm: boolean = true;
  mobileReg: RegExp = /^[6-9]\d{9}$/;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private easebuzzAPI: EaseBuzzAPIService,
    private location: Location
  ) {}
  form: FormGroup;
  form1: FormGroup;
  form2: FormGroup;
  ngOnInit() {
    if (
      history.state.compId == (null || undefined) &&
      history.state.points == (null || undefined)
    ) {
      this.router.navigateByUrl("/404");
    } else {
      this.vObj = history.state;
      this.isBank = this.vObj.isBank;
      this.isUPI = this.vObj.isUPI;
      this.isPaytm = this.vObj.isPaytm;
      if (!this.isBank && !this.isPaytm) this.option = "1";
      if (!this.isBank && !this.isUPI) this.option = "3";
      if (!this.isUPI && !this.isPaytm) this.option = "2";
    }
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      name: ["", Validators.required],
      account_no: ["", Validators.required],
      ifsc: ["", Validators.required],
      compId: "",
      mobileNo: ["", [Validators.required, Validators.pattern(this.mobileReg)]],
    });
    this.form1 = this.fb.group({
      name: ["", Validators.required],
      vpa: ["", Validators.required],
      compId: "",
      mobileNo: ["", [Validators.required, Validators.pattern(this.mobileReg)]],
    });
    this.form2 = this.fb.group({
      name: ["", Validators.required],
      paytmNo: ["", Validators.required],
    });
  }

  onSubmit() {
    if (this.option == "2") {
      if (this.form.valid) {
        this.form.patchValue({ compId: this.vObj.compId });
        this.TransferUsingAccount();
        // this.easebuzzAPI.CheckAccount(this.form.value).subscribe((res) => {
        //   if (res.responseCode == "200") {
        //     console.log(res);
        //     this.TransferUsingAccount();
        //   } else {
        //     this.messageService.add({
        //       severity: "error",
        //       summary: "Oops",
        //       detail: res.responseMessage,
        //     });
        //   }
        // });
      } else {
        this.messageService.add({
          severity: "error",
          summary: "Oops",
          detail: "Please Enter All Details",
        });
      }
    } else if (this.option == "1") {
      if (this.form1.valid) {
        this.form1.patchValue({ compId: this.vObj.compId });
        this.TransferUsingUPI();
        // this.easebuzzAPI.CheckUPI(this.form1.value).subscribe((res) => {
        //   if (res.responseCode == "200") {
        //     console.log(res);
        //     this.TransferUsingUPI();
        //   } else {
        //     this.messageService.add({
        //       severity: "error",
        //       summary: "Oops",
        //       detail: res.responseMessage,
        //     });
        //   }
        // });
      } else {
        this.messageService.add({
          severity: "error",
          summary: "Oops",
          detail: "Please Enter All Details",
        });
      }
    } else if (this.option == "3") {
      if (this.form2.valid) {
        var formData = new FormData();
        formData.append("compPrefix", this.vObj.prefix);
        formData.append("qrData", this.vObj.qrData);
        formData.append("mobNo", this.form2.value.paytmNo);
        formData.append("points", this.vObj.points);
        formData.append("seqNo", this.vObj.seqNo);
        formData.append("compId", this.vObj.compId);
        formData.append("verificationId", this.vObj.verificationId);
        var object = {};
        formData.forEach(function (value, key) {
          object[key] = value;
        });
        this.easebuzzAPI.WalletTransfer(object).subscribe((res) => {
          console.log(res);
          if (
            res.responseCode == "200"
            // && res.data != (null || undefined) &&
            // res.data.paytmStatusType != (null || undefined) &&
            // res.data.paytmStatusType == 200
          ) {
            this.initForm();
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.responseMessage,
            });
            this.tranComplete = true;
            sessionStorage.setItem("tranComplete", "1");
            sessionStorage.setItem("backFromRedemption", "1");
            setTimeout(() => {
              this.location.back();
              //window.location.href = `${this.vObj.qrData}`;
              return;
            }, 10000);
          } else {
            this.messageService.add({
              severity: "error",
              summary: "Oops",
              detail:
                res.responseMessage +
                ". This maybe a wrong Paytm Wallet Number",
            });
            setTimeout(() => {
              //this.location.back();
              sessionStorage.setItem("tranComplete", "0");
              window.location.href = `${this.vObj.qrData}`;
              return;
            }, 5000);
          }
        });
      }
    }
  }

  resetForms() {}

  TransferUsingAccount() {
    var formData = new FormData();
    formData.append("key", "");
    formData.append("beneficiary_type", "bank_account");
    formData.append("beneficiary_name", this.form.value.name);
    formData.append("account_number", this.form.value.account_no);
    formData.append("ifsc", this.form.value.ifsc);
    formData.append("payment_mode", "IMPS");
    formData.append("amount", this.vObj.points);
    formData.append("upi_handle", "");
    formData.append("seqNo", this.vObj.seqNo);
    formData.append("compId", this.vObj.compId);
    formData.append("mobileNo", this.form.value.mobileNo);
    formData.append("verificationId", this.vObj.verificationId);
    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    this.easebuzzAPI.QuickTransferAsync(object).subscribe((res) => {
      if (res.responseCode == "200") {
        this.initForm();
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: res.responseMessage,
        });
        this.tranComplete = true;
        sessionStorage.setItem("tranComplete", "1");
        sessionStorage.setItem("backFromRedemption", "1");
        setTimeout(() => {
          window.location.href = `${this.vObj.qrData}`;
          return;
        }, 10000);
      } else {
        this.messageService.add({
          severity: "error",
          summary: "Oops",
          detail: res.responseMessage,
        });
        sessionStorage.setItem("tranComplete", "0");
        setTimeout(() => {
          window.location.href = `${this.vObj.qrData}`;
          return;
        }, 5000);
      }
    });
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event) {
    sessionStorage.setItem("backFromRedemption", "1");
  }

  TransferUsingUPI() {
    var formData = new FormData();
    formData.append("key", "");
    formData.append("beneficiary_type", "upi");
    formData.append("beneficiary_name", this.form1.value.name);
    formData.append("account_number", "");
    formData.append("ifsc", "");
    formData.append("payment_mode", "UPI");
    formData.append("amount", this.vObj.points);
    formData.append("upi_handle", this.form1.value.vpa);
    formData.append("seqNo", this.vObj.seqNo);
    formData.append("compId", this.vObj.compId);
    formData.append("mobileNo", this.form1.value.mobileNo);
    formData.append("verificationId", this.vObj.verificationId);
    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    this.easebuzzAPI.QuickTransferAsync(object).subscribe((res) => {
      if (res.responseCode == "200") {
        this.initForm();
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: res.responseMessage,
        });
        this.tranComplete = true;
        sessionStorage.setItem("tranComplete", "1");
        sessionStorage.setItem("backFromRedemption", "1");
        setTimeout(() => {
          window.location.href = `${this.vObj.qrData}`;
          return;
        }, 10000);
      } else {
        this.messageService.add({
          severity: "error",
          summary: "Oops",
          detail: res.responseMessage,
        });
        sessionStorage.setItem("tranComplete", "0");
        setTimeout(() => {
          window.location.href = `${this.vObj.qrData}`;
          return;
        }, 5000);
      }
    });
  }
}
